import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gql, useQuery } from '@apollo/client';

var _templateObject;
var ProfileCompletionGraphQlQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query ProfileCompletion {\n        profileCompletion {\n            progress\n        }\n    }\n"])));
var updateProfileCompletionCache = function updateProfileCompletionCache(cache, eventData) {
  var ProfileCompletionQueryOptions = {
    query: ProfileCompletionGraphQlQuery
  };
  cache.writeQuery(_objectSpread(_objectSpread({}, ProfileCompletionQueryOptions), {}, {
    data: {
      profileCompletion: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __typename: 'ProfileCompletion',
        progress: eventData.profileProgress
      }
    }
  }));
};
var useProfileCompletionQuery = function useProfileCompletionQuery() {
  var _data$profileCompleti;
  var _useQuery = useQuery(ProfileCompletionGraphQlQuery),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  return {
    profileCompletionProgress: data === null || data === void 0 ? void 0 : (_data$profileCompleti = data.profileCompletion) === null || _data$profileCompleti === void 0 ? void 0 : _data$profileCompleti.progress,
    isLoading: loading,
    error: error
  };
};

export { ProfileCompletionGraphQlQuery, updateProfileCompletionCache, useProfileCompletionQuery };
